<script setup lang="ts">
const authStateStore = useAuthStateStore()

const onSubmit = async () => {
  await navigateTo('/signin')
}

const onUpdateModelValue = (_v: boolean | undefined) => {
  // persistent modal: ignore any attempted close.
  // The dialog closes only by navigating away on submit, which unmounts this
  // component with the layout.
}
</script>

<template>
  <Dialog
    :model-value="authStateStore.isSessionExpired"
    title="セッションの有効期限が切れました"
    :submit-button="{ title: 'もう一度入る' }"
    @submit="onSubmit"
    @update:model-value="onUpdateModelValue"
  >
    <div class="session-expired-body">
      書きかけの魔導書はこのブラウザに保管されています。
      <br>
      もう一度入り直せば、続きから編集できます。
    </div>
  </Dialog>
</template>

<style scoped>
.session-expired-body {
  font-size: max(13.33px, calc(1.875 * var(--u)));
  line-height: 1.7;
  padding: max(8.89px, calc(1.25 * var(--u)));
  text-align: center;
}
</style>
